import { Button, Dialog } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { useInvalidateRepositoryQuery, useRepositoryMutation } from '@mews-commander/data-access';
import { LocalizedParagraph } from '@mews-commander/ui';

interface Props {
    active: boolean;
    onClose: () => void;
    passkeyId: string;
}

export const PasskeyDeleteDialog = ({ active, onClose, passkeyId }: Props) => {
    const { mutate: deleteKey } = useRepositoryMutation('users', 'deletePasskey', {
        onSuccess: () => {
            void invalidateQuery('users', 'getRegisteredCredentials');
            showSuccessAlert({
                description: <LocalizedText textKey={TextKey.SettingsSecurityPasskeysRemoveSuccess} />,
            });
        },
    });

    const invalidateQuery = useInvalidateRepositoryQuery();

    const onDelete = () => {
        deleteKey({ passkeyId });
    };

    return (
        <Dialog
            active={active}
            onClose={onClose}
            title={<LocalizedText textKey={TextKey.SettingsSecurityPasskeysRemoveTitle} />}
            footer={{
                secondary: (
                    <Button onClick={onClose} variant="tertiary" type="button">
                        <LocalizedText textKey={TextKey.GoBack} />
                    </Button>
                ),
                primary: (
                    <Button
                        onClick={() => {
                            onDelete();
                            onClose();
                        }}
                        variant="destructive"
                        type="submit"
                    >
                        <LocalizedText textKey={TextKey.Remove} />
                    </Button>
                ),
            }}
            size="small"
        >
            <LocalizedParagraph textKey={TextKey.SettingsSecurityPasskeysRemoveBodyFirstParagraph} />
            <br />
            <LocalizedParagraph textKey={TextKey.SettingsSecurityPasskeysRemoveBodySecondParagraph} />
        </Dialog>
    );
};
